import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=2f23cab0&scoped=true"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23cab0",
  null
  
)

export default component.exports